import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

function ErrorMessage() {
  return (
    <div className="dtv-html5-c-search__error-message">
      <p className="dtv-html5-c-search__error-message-title">
        <FormattedMessage
          id="search.results.noResults.title"
        />
      </p>
      <p className="dtv-html5-c-search__error-message-subtitle">
        <FormattedMessage id="search.results.noResults.firstLine" />
      </p>
    </div>
  );
}

export default memo(ErrorMessage);
